/* eslint-disable no-return-assign */
import BlockedSubscription from 'components/molecules/blocked_subscription';
import ViewCourse from 'components/molecules/view_course';
import ListModules from 'components/organisms/list_modules';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { getDataCourse } from 'store/modules/course_store/actions';
import { PanelState } from 'store/modules/panel_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import { getLastClass } from 'store/modules/progression_course_store/actions';

const Course = () => {
  const [searchBarOpened, setSearchBarOpened] = useState<boolean>(true);
  const dispatch = useDispatch();

  const { panel, request } = useSelector<ApplicationState, PanelState>(
    (state) => state.session.panel,
  );
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const videoRef = useRef<HTMLDivElement | null>(null);

  const scrollToVideo = () => {
    videoRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  useEffect(() => {
    dispatch(getDataCourse(2));
    dispatch(getLastClass(2));
  }, []);

  return (
    <div className="page-container">
      {profile.paralyzed ? (
        <BlockedSubscription paralyzed={profile.paralyzed} />
      ) : (panel?.validate_services?.course_iaml || panel?.registration_type_validation === 1) &&
        request?.loaded ? (
        <>
          <ListModules
            scrollToVideo={scrollToVideo}
            setSearchBarOpened={setSearchBarOpened}
            searchBarOpened={searchBarOpened}
            courseSubscriber={panel?.validate_services?.course_iaml}
          />
          <ViewCourse
            videoRef={videoRef}
            searchBarOpened={searchBarOpened}
            subscriber={panel?.validate_services?.course_iaml}
          />
        </>
      ) : (
        (window.location.href = '/painel')
      )}
    </div>
  );
};
export { Course };
